<template>
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8"
          y="8"
          width="10"
          height="10"
          rx="1"
          fill="currentColor" />
    <path d="M25.5 13C25.5 19.9036 19.9036 25.5 13 25.5C6.09644 25.5 0.5 19.9036 0.5 13C0.5 6.09644 6.09644 0.5 13 0.5C19.9036 0.5 25.5 6.09644 25.5 13Z" stroke="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'StopOutlined',
};
</script>
